import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CadData from "./components/pages/cadData/CadData";
import CadDataDX from "./components/pages/cadDataDX/CadDataDX.js";
import CadDataDXUpload from "./components/pages/cadDataDX/CadDataDXUpload.js";
import CadByItemPdf from "./components/pages/cadByItemPdf/CadByItemPdf";
import TestReport from "./components/pages/testReport/TestReport";
import FabricTestReport from "./components/pages/fabricTestReport/FabricTestReport";
import StyleColorImg from "./components/pages/styleColorImg/StyleColorImg";
import MilkyWayDownloadCN from "./components/pages/milkyWayDownload/MilkyWayDownloadCN";
import MilkyWayDownloadFNCo from "./components/pages/milkyWayDownload/MilkyWayDownloadFNCo";
import MilkyWayDownloadHQ from "./components/pages/milkyWayDownload/MilkyWayDownloadHQ";
import GraphicMaster from "./components/pages/graphic/GraphicMaster";
import PLMOrder from "./components/pages/plmOrder/PLMOrder";
import Title from "./utils/title";
import "./utils/i18n.js";
import { LicenseInfo } from "@mui/x-license-pro";
import Files from "./components/pages/matrixBoard/Files";
import MatrixBoard from "./components/pages/matrixBoard/MatrixBoard";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ProtectedRouteDX from "./components/auth/ProtectedRouteDX";
import { UserProvider } from "./contexts/UserContext";
LicenseInfo.setLicenseKey("bdd2fba0c1674c6e17d94906bf2f3ab8Tz0xMTk0OTgsRT0xNzkwMzgwNzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y");

function App() {
  return (
    <UserProvider>
      <Router>
        <Title>
        <Routes>
          {/* 밀키웨이 다운로드 */}
          <Route path="/" element={<MilkyWayDownloadHQ />} /> 
          <Route path="/CNdownload" element={<MilkyWayDownloadCN />} /> 
          <Route path="/fnco-download" element={<MilkyWayDownloadFNCo />} /> 

          {/* 발주현황 */}
          <Route path="/plm_order/:id" element={<PLMOrder />} /> 

          {/* 캐드 대시보드 */}
          <Route path="/interstellar/M/caddata" element={<ProtectedRoute><CadData /></ProtectedRoute>} /> 
          <Route path="/interstellar/X/caddata" element={<ProtectedRouteDX><CadDataDX /></ProtectedRouteDX>} /> 
          <Route path="/interstellar/X/caddata/upload" element={<ProtectedRouteDX><CadDataDXUpload /></ProtectedRouteDX>} />
          <Route path="/interstellar/M/caddata/pdf" element={<CadByItemPdf />} />

          {/* 그래픽 마스터 */}
          <Route path="/interstellar/M/graphic" element={<ProtectedRoute><GraphicMaster /></ProtectedRoute>} />

          {/* DX 성적서 */}
          <Route path="/interstellar/X/test-report" element={<TestReport />} /> 
          <Route path="/interstellar/X/fabric-test-report" element={<FabricTestReport />} />

          {/* 컬러별 이미지 업로드 */}
          <Route path="/interstellar/X/stylecolorimg" element={<StyleColorImg />} />
          <Route path="/interstellar/V/stylecolorimg" element={<StyleColorImg />} />
          <Route path="/interstellar/ST/stylecolorimg" element={<StyleColorImg />} />
          <Route path="/interstellar/I/stylecolorimg" element={<StyleColorImg />} />

          {/* 매트릭스 보드 - Microsoft SSO 인증 필요 */}
          <Route path="interstellar/matrix-board" element={<ProtectedRoute><Files /></ProtectedRoute>} />
          <Route path="interstellar/matrix-board/:fileId" element={<ProtectedRoute><MatrixBoard /></ProtectedRoute>} />
        </Routes>
      </Title>
      </Router>
    </UserProvider>
  );
}

export default App;
